import CloseIcon from "@mui/icons-material/Close";

import type { ExternalWidgetTicketinghub as ExternalWidgetTicketinghubType } from "../../types/ExternalWidget";
import { ModalDeprecated, ModalLayout } from "../ModalDeprecated";
import { Ticketinghub } from "./Ticketinghub";

export type ExternalWidgetTicketinghubContentProps = Pick<ExternalWidgetTicketinghubType, "widgetId"> & {
    open: boolean;
    onClose: () => void;
};

export function ExternalWidgetTicketinghubContent({ widgetId, open, onClose }: ExternalWidgetTicketinghubContentProps) {
    return (
        <>
            <ModalDeprecated open={open} keepMounted={true} onClose={onClose}>
                <ModalLayout header={<CloseIcon aria-label="close" color="primary" onClick={onClose} />}>
                    <Ticketinghub widgetId={widgetId} />
                </ModalLayout>
            </ModalDeprecated>
        </>
    );
}
